import { TextField, Box } from "@mui/material";
import { colors } from "../../../../styles/Variables";

export const FormInput = ({ label, name, value, onChange }) => (
    <TextField
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        variant="outlined"
        size="small"
        fullWidth
        sx={{ mb: 2, backgroundColor: "#fff", borderRadius: 1 }}
        InputLabelProps={{ sx: { fontWeight: "700", color: "#16164E" } }}
    />
);
